import * as v from 'valibot';

import { type Entities, optionSchema } from './_core.model';
import { countryApiSchema } from './countries.model';
import { stateApiSchema } from './states.model';

export const cityApiSchema = v.object({
  cityName: v.string(),
  country: countryApiSchema,
  countryCode: v.null(),
  postalCode: v.string(),
  postalKey: v.number(),
  state: stateApiSchema,
});

export const citiesApiSchema = v.array(cityApiSchema);

export const citiesParamsSchema = v.object({
  CountryCode: v.string(),
  StateCode: v.string(),
});

export type CityApi = v.InferOutput<typeof cityApiSchema>;
export type CitiesApi = v.InferOutput<typeof citiesApiSchema>;
export type CitiesParams = v.InferOutput<typeof citiesParamsSchema>;

export const citySchema = v.object({
  ...optionSchema.entries,
});

export type City = v.InferOutput<typeof citySchema>;

export type Cities = Entities<City>;

export type CityFilters = {
  search?: {
    cityName?: string;
  };
};
